import '@hotmart/cosmos/dist/tag'
import { Size, TagProps } from './tag.types'

const Tag = ({ children, className, size = Size.sm }: TagProps) => {
  return <hot-tag class={`${size} ${className}`}>{children}</hot-tag>
}

export default Tag
